import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { routerPaths } from "../../constants/Paths";
import { CircularProgress, Stack, Typography } from "@mui/material";
import { useLangContext } from "../../context/langContext";

const compInfo = {
  fa: "شما در حال انتقال به صفحه پرداخت هستید، لطفا منتظر بمانید.",
  en: "you are transferring to payment page, please wait",
};

export default function TransferPage() {
  const [searchParam] = useSearchParams();
  const url = searchParam.get("paymentUrl");
  const { lang } = useLangContext();
  const navigate = useNavigate();
  const info = compInfo[lang];
  useEffect(() => {
    const timeoutId = setTimeout(() => {
      handleSubmit();
    }, 1000);

    return () => clearTimeout(timeoutId);
  }, []);

  const handleSubmit = async () => {
    if (url) {
      window.location.replace(url);
    } else {
      navigate(routerPaths.DASHBOARD);
    }
  };

  return (
    <Stack
      width="100%"
      height="100vh"
      justifyContent={"center"}
      alignItems={"center"}
    >
      <form hidden style={{ display: "none" }} onSubmit={handleSubmit} />

      <Stack
        direction="row"
        justifyContent="center"
        alignItems={"center"}
        gap="12px"
      >
        <Typography variant="h6DemiBold">{info}</Typography>
        <CircularProgress />
      </Stack>
    </Stack>
  );
}
